import { Component, OnInit, ChangeDetectionStrategy } from "@angular/core";
import { Router } from "@angular/router";
import { AuthService, FirebaseAnalyticsService } from "@modules/core";

@Component({
  selector: "app-logout-oidc",
  templateUrl: "./logout-oidc.component.html",
  styleUrls: ["./logout-oidc.component.scss"],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class LogoutOidcComponent implements OnInit {
  constructor(
    private authService: AuthService,
    private analytics: FirebaseAnalyticsService,
    private router: Router
  ) {}

  ngOnInit() {
    this.analytics.logEvent("sign_out");
    this.analytics.logEvent("logout");
    this.authService.afterLogout();
    this.router.navigateByUrl("/");
  }
}
